/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 08.10.25
 *
 */
export const SessionNoteTypeEnum = Object.freeze({
	REFLECTION: "REFLECTION",
	BEHAVIOR_TREE_NOTES: "BEHAVIOR_TREE_NOTES",
	REF_PREV_SESSION: "REF_PREV_SESSION",
	REF_BT_SESSION: "REF_BT_SESSION",
	PREV_SESSION: "PREV_SESSION",
	AIMS: "AIMS",
	HOW_TO_AIMS: "HOW_TO_AIMS",
	TOOLS: "TOOLS",
	MATERIALS: "MATERIALS",
	TLSW_BOOK: "TLSW_BOOK",
	OUTCOME: "OUTCOME",
	EVALUATION: "EVALUATION",
	REFLECTIONS: "REFLECTIONS",

	BEHAVIOR_TREE_LEAVES: "BEHAVIOR_TREE_LEAVES",
	BEHAVIOR_TREE_ROOTS: "BEHAVIOR_TREE_ROOTS",
	BEHAVIOR_TREE_DISCUSSION: "BEHAVIOR_TREE_DISCUSSION",


	GENERAL_TEXT: "GENERAL_TEXT",
	GENERAL_TAGS: "GENERAL_TAGS",
})

export function displayTypeFromNoteType(noteType) {
	switch (noteType) {
		case SessionNoteTypeEnum.REFLECTION:
		case SessionNoteTypeEnum.BEHAVIOR_TREE_NOTES:
		case SessionNoteTypeEnum.REF_PREV_SESSION:
		case SessionNoteTypeEnum.REF_BT_SESSION:
		case SessionNoteTypeEnum.AIMS:
		case SessionNoteTypeEnum.HOW_TO_AIMS:
			return SessionNoteTypeEnum.GENERAL_TEXT
		case SessionNoteTypeEnum.TOOLS:
		case SessionNoteTypeEnum.MATERIALS:
			return SessionNoteTypeEnum.GENERAL_TAGS
		default:
			return noteType
	}
}
